import React from 'react';
import { createRoot } from 'react-dom/client';  // Use createRoot from 'react-dom/client'
import { Provider } from 'react-redux';
import store from './redux/store'; // Adjust the path as necessary
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const rootElement = document.getElementById('root');
const root = createRoot(rootElement);  // Initialize with createRoot

root.render(
  <Provider store={store}>
    <React.StrictMode>
      <App />
    </React.StrictMode>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
